import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mark-read"
export default class MarkReadController extends Controller {
  static values = {
    id: Number,
    url: String,
    turbo: Boolean,
    frameName: { type: String, default: 'scroll_modal_content'}
  }

  click(event) {
    event.preventDefault()

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        turbo: this.turboValue,
        turbo_frame: this.turboValue ? this.frameNameValue : "_top"
      })
    })
      .then(async (response) => {
        if (response.redirected) {
          Turbo.visit(response.url)
          return
        }

        const body = await response.text()
        Turbo.renderStreamMessage(body)
      })
  }

  markRead(event) {
    if (this.idValue === 0) return;

    fetch(`/notifications/${this.idValue}/mark_as_read`, {
      method: 'PATCH',
      headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        turbo: "false",
        turbo_frame: "_top"
      }),
      credentials: 'include'
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error('Turbo request failed:', error))
  }
}
